<template>
<v-card>
          <v-card-text>
            <v-form>
                <v-row no-gutters class="ml-3 mr-3 pt-3">
                    <v-col cols="12">
                        <h4>Would you recommend this doctor to others?</h4>
                    </v-col>
                    <v-col cols="12">
                    
                    <v-chip-group                                                        
                    mandatory                                                             
                    v-model="reviewObj.reviewIsrecommended"                                                   
                    active-class="green--text text--accent-4"
                    >                                                        
                    <v-chip
                    :outlined="reviewObj.reviewIsrecommended==='false'"
                    class="mr-2"
                    color="green"
                    small
                    value="true"
                    >
                    <span :class="reviewObj.reviewIsrecommended==='true' ? 'white--text' : 'green-text' ">Yes</span>
                    
                        <v-icon small :color="reviewObj.reviewIsrecommended==='true' ? 'white' : 'green' " right>mdi-thumb-up</v-icon>
                    </v-chip>
                    <v-chip     
                    small                                                                                                           
                    value="false"
                    :outlined="reviewObj.reviewIsrecommended==='true'"                                                                                                                
                    color="red"                                                        
                    >
                    <span  :class="reviewObj.reviewIsrecommended==='false' ? 'white--text' : 'red-text' ">No</span>
                        
                        <v-icon small right :color="reviewObj.reviewIsrecommended==='false' ? 'white' : 'red' ">mdi-thumb-down</v-icon>
                    </v-chip>
                    </v-chip-group>
                    </v-col>
                    <v-col cols="12" sm="12" class="mt-5">
                        <v-textarea placeholder="How was your experience?" solo flat rows=2
                                    background-color="grey lighten-3"
                                    v-model="reviewObj.reviewDescription"></v-textarea>
                    </v-col>
                    
                    
                    <v-col cols="12" sm="12" class="text-end">
                        <v-btn @click.prevent="dismissReview" class="primary black--text mr-3"                                    
                                :disabled="reviewObj.reviewLoading"                                    
                                rounded>
                            Cancel
                        </v-btn>
                        <v-btn @click.prevent="submitReview" class="primary black--text"
                                :loading="reviewObj.reviewLoading"
                                :disabled="reviewObj.reviewLoading"
                                rounded>
                            Submit Review                                
                        </v-btn>
                    </v-col>                        
                    
                </v-row>
            </v-form>    
      </v-card-text>
      </v-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
name: "AddReview",
  props: {
    appointmentId: {
      type: String,
      required: false
    }
  },
  computed: {
        ...mapGetters([          
            'userInfo',            
        ]),
    },
  data() {
    return {
      reviewObj:{
        showReviewDialog:false,
        reviewIsrecommended:true,
        reviewDescription:"",
        reviewLoading:false
      }
    }
  },
  methods: {
    dismissReview(){
      this.reviewObj.showReviewDialog = false
      this.$emit('cancel', this.$event)
    },
    submitReview() {
        this.reviewObj.reviewLoading = true
        this.axios.post(`${process.env.VUE_APP_API_URL}/api/ratings/appointment/` + this.appointmentId,{                    
            
            is_recommended:this.reviewObj.reviewIsrecommended,
            description:this.reviewObj.reviewDescription            
        }).then((response) => {
            if(response.data.status == 1){                                                      
                this.show_review = false
                this.reviewDescription = ""
                this.$store.commit('showSnackbar', {message: response.data.message, color: ''})
                this.$emit('review-added', this.$event)
            }                    
            
        }).catch((error) => {
            console.log(error)
        })
        .finally(() => {
            this.reviewLoading = false

        })
    },
  },
  mounted() {}
}
</script>
